module.exports = __webpack_public_path__ + "static/img/topbg.2dc9bfdc.png";